import React from 'react';
import Input from './input/input';
import Select from './select/select';

const Field = ({ typename, ...props }) => {
  switch (typename) {
    case 'STRAPI_ComponentFormsInput':
      return <Input key={props.id} {...props} />;
    case 'STRAPI_ComponentFormsSelect':
      return <Select key={props.id} {...props} />;
    default:
      console.warn('Didn\'t understand the form field __typename');
      return null;
  }
};

export default Field;
